import React from 'react';
import moment from 'moment';

import { FilterType, HandleFilterType } from '../types';
import { maxDate, minDate } from '../validations';

import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TextField } from '@mui/material';

interface FilterComponent {
  handleFilter?: ({ key, value, resetFilter }: HandleFilterType) => void;
  filter?: FilterType;
}

export function Filters({ handleFilter, filter }: FilterComponent) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label="Select Month"
        views={['year', 'month']}
        openTo="year"
        value={filter?.startDate}
        onChange={(newValue: any) => {
          if (handleFilter) {
            handleFilter({
              resetFilter: {
                startDate: moment(new Date(newValue)).startOf('month'),
                endDate: moment(new Date(newValue)).endOf('month'),
              },
            });
          }
        }}
        renderInput={(params) => <TextField {...params} />}
        maxDate={maxDate}
        minDate={minDate}
      />
    </LocalizationProvider>
  );
}
